<template>
  <BaseButton
    :variant="mappedVariant"
    :class="['stylist-button', variant]"
    @click="emit('click', $event)">
    <template #icon>
      <slot name="icon"/>
    </template>
    <slot/>
  </BaseButton>
</template>

<script setup>
import { computed } from 'vue'
import BaseButton from './BaseButton.vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'light', 'text-link'].includes(value)
  }
})

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})

const mappedVariant = computed(() => {
  switch (props.variant) {
    case 'light':
      return 'secondary'
    case 'text-link':
      return 'text-link'
    default:
      return 'primary'
  }
})
</script>

<style lang="scss" scoped>
.stylist-button {
  &, &.default {
    background-color: $teal;
    color: $white;

    @media (hover: hover) {
      &:hover {
        background-color: $teal-dark;
      }
    }
    &:focus:not(:hover), &:active {
      background-color: $teal-dark;
    }
  }
  &.light {
    background-color: $white;
    color: $teal;
    border: unset;

    @media (hover: hover) {
      &:hover {
        background-color: $teal;
        color: $white;
      }
    }
    &:focus:not(:hover), &:active {
      background-color: $teal;
      color: $white;
    }
  }
  &.text-link {
    background-color: transparent;
    color: $teal;
    font-weight: $font-weight-normal;

    @media (hover: hover) {
      &:hover {
        color: $teal-dark;
      }
    }
    &:focus:not(:hover), &:active {
      color: $teal-dark;
    }
  }
}
</style>
